import { getProductFlowConfiguration } from '@flows/configs/shared/flowConfiguration'
import type { FlowConfigProps, StepConfigParams } from '@flows/configs/types'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'
import { generateGetFlowValueFunctions } from '@flows/insurance/utils'

import schema from './schema'
import getDogLiabilityNxtSteps from './steps'

const getDogLiabilityConfig = ({ clientHelpers, market }: FlowConfigProps) => {
  const FIRST_STEP_NAME = 'dog_list'
  const productKey = 'dog_liability_v1_getsafe_de'
  const params: StepConfigParams = {
    clientHelpers,
    productKey,
    helperFunctions: generateGetFlowValueFunctions(productKey),
    subFlow: SubFlow.DogLiability,
    market,
  }

  return getProductFlowConfiguration(productKey, getDogLiabilityNxtSteps(params), {
    constants: {
      FIRST_STEP_NAME,
      SCHEMA: schema,
    },
    getInitialValues: () => {
      return {
        [productKey]: {
          productKey,
          configuration_parameters: {
            sos_help_coverage: true,
            tariff_line: 'premium',
            deductible_amount: 0,
          },
        },
      }
    },
  })
}

export default getDogLiabilityConfig
